import { useTranslation } from 'react-i18next';

import { usePuzzleDay } from '../hooks/usePuzzleDay';

const Footer = () => {
  const { t } = useTranslation();
  const { puzzleNumber } = usePuzzleDay();

  return (
    <footer className="flex flex-col w-full mt-10 pt-4 gap-1 justify-center items-center text-center border-t border-gray-100 dark:border-slate-700">
      <p className="text-xs text-gray-500 dark:text-gray-400">
        {t('footer.tagline')}
      </p>
      <p className="text-xs text-gray-400 dark:text-gray-500">
        Flagle #{puzzleNumber}
        <span aria-hidden="true"> · </span>
        <a
          href="https://teuteuf.fr/"
          target="_blank"
          rel="noreferrer"
          className="hover:underline"
        >
          {t('footer.madeBy')}
        </a>
      </p>
    </footer>
  );
};

export default Footer;
